import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import type { DashboardMode, DashboardScopeType } from '../../../interfaces/Dashboard.interface';
import {
    type BusinessIntelligenceWidgetConfig,
    type TailoredWidgetConfig,
    TailoredWidgetType,
    type TemplateWidgetConfig
} from '../../../interfaces/TailoredWidget.interface';
import { TailoredWidgetTemplateEditorComponent } from '../../template-widget-editor/template-widget-editor';
import { BusinessIntelligenceWidgetConfigEditorComponent } from '../business-intelligence-widget-config-editor/business-intelligence-widget-config-editor';

export interface TailoredWidgetConfigChangedEvent {
    isValid: boolean;
    forbiddenDashboardModes: DashboardMode[];
    config: TailoredWidgetConfig;
}

export interface BusinessIntelligenceWidgetConfigChangedEvent extends TailoredWidgetConfigChangedEvent {
    config: BusinessIntelligenceWidgetConfig;
}

export interface WidgetTemplateConfigChangedEvent extends TailoredWidgetConfigChangedEvent {
    config: TemplateWidgetConfig;
}

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./tailored-widget-config-editor.scss'],
    selector: 'tailored-widget-config-editor',
    templateUrl: 'tailored-widget-config-editor.html',
    imports: [BusinessIntelligenceWidgetConfigEditorComponent, TailoredWidgetTemplateEditorComponent]
})
export class TailoredWidgetConfigEditorComponent {
    @Input() configToEdit!: TailoredWidgetConfig;
    @Output() configChanged: EventEmitter<TailoredWidgetConfigChangedEvent> = new EventEmitter<TailoredWidgetConfigChangedEvent>();

    @Input() acceptedDashboardModes!: DashboardMode[];
    @Input() dashboardScopeType!: DashboardScopeType;
    @Input() isEditing!: boolean;

    tailoredWidgetType = TailoredWidgetType;

    ngOnInit() {}

    childConfigChanged(config: TailoredWidgetConfigChangedEvent) {
        this.configChanged.emit(config);
    }
}
